import { Configuration } from "@kortobaa-front/k-ng-datatable";
import { environment } from "src/environments/environment";

export const kNgDataTablePkgConfig: Configuration = {
  APIHost: environment.apiHost,
};
